<template>
  <b-row>
    <b-col>
    <vue-form-generator
      id="guarantor-entity-form"
      :schema="schema.schema"
      :model="model"
      :options="schema.options"
      ref="guarantorForm"
    />
    <additional-content
      class="col-md-12"
      v-if="entity"
      :entity="entity"
      ref="additionalContent"
      :borrower-docs="false"
      :entity-docs="false"
    />
      <div class="w-100 text-right mt-3 col-md-12">
        <verification-user-email
          ref="verificationUserAlertPreview"
          placement="left"
          target="preview-button"
        />
        <span id="preview-container">
          <b-button
            class="btn-anchor raised mt-2"
            id="application-preview-button"
            ref="previewButton"
            @click="preview"
          >
            Start Application and eSign
          </b-button>
        </span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import AdditionalContent from '@/components/profile/sections/tabs/application/form/AdditionalContent';
import ENTITY_SCHEMA from '@/components/borrower_application/resources/schema';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';

export default {
  name: 'GuarantorEntityForm',
  data() {
    return {
      model: { type: 'entity', entity: null },
    };
  },
  components: {
    'vue-form-generator': VueFormGenerator.component,
    AdditionalContent,
    VerificationUserEmail,
  },
  computed: {
    entity() {
      return this.$store.getters.entities.find(entity => entity.id === this.model.entity);
    },
    entities() {
      return this.$store.getters.entities;
    },
    schema() {
      const entityOptions = this.entities.map(entity => ({
        id: entity.id,
        name: entity.name,
      }));

      return {
        schema: ENTITY_SCHEMA.schema(
          entityOptions,
          false,
          '',
        ),
        options: ENTITY_SCHEMA.options,
      };
    },
  },
  methods: {
    validate() {
      return this.$refs.guarantorForm.validate();
    },
    preview() {
      if (this.$refs.verificationUserAlertPreview.isVerified) {
        this.$refs.previewButton.blur();
        this.$emit('submit', this.model);
      }
    },
  },
  mounted() {
    const profile = this.$store.getters.profile;
    if (profile && profile.application) {
      this.model = {
        type: 'entity',
        entity: profile.application.entity,
      };
    }
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/borrower_application/resources/GuarantorEntityForm.vue